import React from 'react'

function HeaderInfoRightTop() {
	return <div></div>
}

export default HeaderInfoRightTop
